export default __webpack_public_path__ + "static/media/token-1.c23397f1.png";